import React, {} from 'react';
const styles = {"auth-split-layout":"AuthSplitLayout-module__auth-split-layout__gbdx6","panel":"AuthSplitLayout-module__panel__8K8jr","media":"AuthSplitLayout-module__media__gmgxx"};
export function AuthSplitLayout({ panel, media }) {
    return (React.createElement("div", { className: styles['auth-split-layout'] },
        React.createElement("div", { className: styles.panel }, panel),
        React.createElement("div", { className: styles.media }, media)));
}
//# sourceMappingURL=AuthSplitLayout.js.map